import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import AppHelper from 'helpers/AppHelper';
import useStyles from './styles';
import { generateBriks } from 'utils';
import { BrikCreationCard } from './BrikCreationCard';
import {
  Tooltip,
} from '@material-ui/core';
import { iconInfor } from 'assets/icons';
interface ChooseBrikTypeNameProps {
  item?: any,
  isEdit?: boolean,
  type?: number,
  nextStep: (e: any, type: any) => void,
  backStep: (e: any, type: any) => void,
  handleSetTypeName?: (type: number) => void,
}

const ChooseBrikTypeName = (props: ChooseBrikTypeNameProps) => {
  const styles = useStyles();

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  // TO BE REMOVE IN THE FUTURE
  const OnDemand = React.forwardRef(function OnDemand(props: any, ref: any) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
          <BrikCreationCard
            key={props?.id}
            image={props?.item?.image}
            title={props?.item?.title}
            description={props?.item?.description}
            onPress={props?.item?.onPress}
          />
      </div>
    );
  });
  
  return (
    <div className={styles.onboadingContainer}>
      <div className={styles.iconCloseIcon} onClick={onHandleCloseModal} data-cy="cypress-brik-type-closed-button-modal">
        <CloseIcon />
      </div>
      <div className={styles.contentTitle} data-cy="cypress-brik-type-modal-header">
        What Briks would you like to create first?
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.rowBrikType}>
          {generateBriks(props?.nextStep, props?.handleSetTypeName).slice(0, 2).map((item, id) => (
            <BrikCreationCard
              key={id}
              image={item.image}
              title={item.title}
              description={item.description}
              onPress={item.onPress}
              dataCy={`cypress-course-type-${id}`}
              dataCyTitle={`cypress-course-option-${id}`}
            />
          ))}
        </div>
        <div className={styles.rowBrikType}>
          {generateBriks(props?.nextStep, props?.handleSetTypeName).slice(2, 4).map((item, id) => {
            return (
              <>
                {
                  id === 1 ? 
                    <Tooltip
                      placement='bottom'
                      title={
                        <span style={{ whiteSpace: 'pre-line' }}>{`Coming Soon!!`}</span>
                      }
                      classes={{
                        tooltip: styles.tooltip,
                        arrow: styles.popupTooltip,
                      }}
                    >
                      <OnDemand id={id} item={item} />
                    </Tooltip> :   
                    <BrikCreationCard
                      key={id}
                      image={item.image}
                      title={item.title}
                      description={item.description}
                      onPress={item.onPress}
                      dataCy={`cypress-course-type-${id}`}
                    />
                }

              </>
 
            );
          })}
        </div>
        <div className={styles.rowBrikType}>
          {generateBriks(props?.nextStep, props?.handleSetTypeName).slice(4, 6).map((item, id) => (
            <BrikCreationCard
              key={id}
              image={item.image}
              title={item.title}
              description={item.description}
              onPress={item.onPress}
              dataCy={`cypress-course-type-${id}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChooseBrikTypeName;
